module.exports = __webpack_public_path__ + "assets/img/getAuthorization.cee0b849.png";